var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hisworks" }, [
    _c("div", { staticClass: "worksWarp" }, [
      _c(
        "div",
        { staticClass: "worksMain" },
        [
          _c("RealTitle", {
            attrs: { titleInfo: _vm.titleInfo, backPath: _vm.backPath },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "worksContent" }, [
            _c("div", { staticClass: "hisWorkTabs" }, [
              _c(
                "div",
                { staticClass: "hisWorkTabsItemsWarp" },
                _vm._l(_vm.hisWorksTypeInfo.title, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      class: [
                        "hisWorkTabsItems",
                        _vm.itemsActNum === j ? "act" : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.items(j)
                        },
                      },
                    },
                    [
                      j === _vm.hisWorksTypeInfo.title.length - 1
                        ? _c("div", { on: { click: _vm.goWorksOfYear } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(i) +
                                "\n              "
                            ),
                          ])
                        : _c("div", [_vm._v(_vm._s(i))]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "awardsTabsWarp" },
                _vm._l(_vm.hisWorksTypeInfo.awards, function (i, j) {
                  return _c(
                    "div",
                    {
                      key: j,
                      class: [
                        "awardsTabs",
                        _vm.awardsActNum === j ? "act" : "",
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.awards(j)
                        },
                      },
                    },
                    [_c("span", [_vm._v(" " + _vm._s(i))])]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "hisWorksListRender" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "renderList" }, [
                _c(
                  "table",
                  {
                    attrs: { border: "0", cellpadding: "0", cellspacing: "1" },
                  },
                  [
                    _c(
                      "tr",
                      _vm._l(_vm.renderInfo.title, function (i, j) {
                        return _c("th", { key: j }, [_vm._v(_vm._s(i))])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.renderInfo.renderList, function (i, j) {
                      return _c(
                        "tr",
                        { key: j },
                        _vm._l(i, function (v, k) {
                          return _c("td", { key: k }, [_vm._v(_vm._s(v))])
                        }),
                        0
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "renderTitle" }, [
      _c("span", [_vm._v("作品列表")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }